import React from "react";

import { connect } from "react-redux";
import {
    reset,
    updateStatus,
    remove,
    list,
    isLoading,
    isLoaded,
    getMeta,
    getList,
    getExtra,
    getError,
    isSecondaryLoading,
} from "../../../../redux/actions/manager/job/list";

import {
    loadCache as loadCacheOld,
    isCacheLoading as isCacheLoadingOld,
    isCacheLoaded as isCacheLoadedOld,
    getProjectsById,
    getProjectsForSelect,
    getPointOfSalesById,
    getPointOfSalesForSelect,
    getComponentsById,
    getComponentsForSelect,
} from "../../../../redux/actions/cache";

import {
    CACHE_LANGUAGE_PAIR,
    CACHE_SERVICE,
    CACHE_UNIT,
    CACHE_LANGUAGE,
    CACHE_VENDOR,
    CACHE_MANAGER,
    loadCache,
    isCacheLoading,
    isCacheLoaded,
    getLanguagesById,
    getLanguagePairsById,
    getCategoriesById,
    getUnitsById,
    getVendorsById,
    getManagersById,
    getManagersForSelect,
} from "../../../../redux/actions/cache/interface";

import { LAYOUT_MANAGER_JOB_NEW } from "../../navigation";

import FullList from "../../../../core/components/listPattern/list";
import listContainer from "../../../../core/components/listPattern/container";

import { basicColumns } from "./fields";
import Filters from "./filters";
import Details from "./details";

const Tabla = (props) => {
    const handleUpdateStatus = (id) => {
        return (form) => {
            return props.updateStatus(id, form);
        };
    };

    return (
        <FullList
            {...props}
            titulo={"JOBS"}
            subtitulo="List"
            onPressNew={LAYOUT_MANAGER_JOB_NEW}
            onSearchByText={(text) => props.onUpdateFilters({ text })}
            resize
            expandable={{
                expandedRowRender: (record) => (
                    <Details
                        {...props}
                        style={{ margin: 0, padding: 0 }}
                        record={record}
                        onDelete={props.remove}
                        onUpdateStatus={handleUpdateStatus(record.id)}
                    />
                ),
                rowExpandable: (record) => true,
                expandedRowClassName: (record, index, indent) => "table-details",
            }}
        >
            <Filters filters={props.parameters} {...props} />
        </FullList>
    );
};

const cacheList = [CACHE_LANGUAGE_PAIR, CACHE_UNIT, CACHE_SERVICE, CACHE_LANGUAGE, CACHE_VENDOR, CACHE_MANAGER];

function MapStateToProps(state) {
    return {
        meta: getMeta(state),
        data: getList(state),
        extra: getExtra(state),

        loading: isLoading(state) || isCacheLoading(state, cacheList) || isCacheLoadingOld(state),
        loaded: isLoaded(state) && isCacheLoaded(state, cacheList) && isCacheLoadedOld(state),
        actionLoading: isSecondaryLoading(state),

        vendorsById: getVendorsById(state),
        languagesById: getLanguagesById(state),
        languagePairsById: getLanguagePairsById(state),
        unitsById: getUnitsById(state),
        categoriesById: getCategoriesById(state),

        projectsById: getProjectsById(state),
        projects: getProjectsForSelect(state),

        pointsOfSale: getPointOfSalesForSelect(state),
        pointsOfSaleById: getPointOfSalesById(state),

        componentsById: getComponentsById(state),
        components: getComponentsForSelect(state),

        managersById: getManagersById(state),
        managers: getManagersForSelect(state),

        error: getError(state),
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        loadCache: () => {
            loadCache(cacheList)(dispatch);
            loadCacheOld(["l3", "l4"])(dispatch);
        },
        list: (query) => dispatch(list(query)),
        updateStatus: (id, form) => dispatch(updateStatus(id, form)),
        remove: (id) => dispatch(remove(id)),
        reset: () => dispatch(reset()),
    };
};

let defaultHidden = [];

defaultHidden["j.elapsedTimeOnReception"] = 1;
defaultHidden["j.deliveryOnTime"] = 1;
export default connect(
    MapStateToProps,
    mapDispatchToProps
)(listContainer(Tabla, { active: 1 }, basicColumns, defaultHidden));
